import { events } from '../../util/Events';
import { Question } from './Question';
import React, { type JSX } from 'react';
import { FaqResponse } from './Faq.model';

type Categories = FaqResponse['categories'];
type Category = Categories[0];
type Subject = Category['subjects'][0];

interface ComponentProps {
  categories: Categories;
  activeCategory: number;
  activeQuestions: number[];
}

export const FaqDesktop = (props: ComponentProps): JSX.Element => {
  const { categories, activeCategory, activeQuestions } = props;

  // get the list of categories
  const categoryList = (
    categories.map((category: Category, key: number) => {
      let catClass = 'faq-list__category';
      if (key === activeCategory) {
        catClass += ' faq-list__category--active';
      }

      return (
        <h2 className={catClass}
          key={key}
          onClick={(): void => events.emit('toggleCategory', key)}>
          {category.title}
        </h2>
      );
    })
  );

  // get the list of questions of the selected category
  const questionList = (
    categories[activeCategory].subjects.map((subject: Subject, key: number) => {
      return (
        <Question
          key={key}
          activeQuestions={activeQuestions}
          index={key}
          question={subject.question}
          answer={subject.answer}/>
      );
    })
  );

  return (
    <div className="row">
      <div className="col-sm-4">
        <ul className="faq-list">
          {categoryList}
        </ul>
      </div>
      <div className="col-sm-8">
        <ul className="faq-list">
          {questionList}
        </ul>
      </div>
    </div>
  );
};
